export enum SidePlacementEnum
{
    left = -1,
    right = 1
}

/**
 * Position de la boîte encadrant le label
 */
export class VerticalPosition
{
    public top: number = 0;
    public bottom: number = 0;
}

/**
 * Position et taille du rectangle virtuel encadrant la zone de texte du label
 */
export class BoundingBox
{
    public x: number;
    public y: number;
    public width: number;
    public height: number;
}
export class Placement
{
    public vpos?: VerticalPosition;
    public coeff: SidePlacementEnum;
    /**
     * Tableau de 3 coordonnées définissant la ligne entre la part et le label
     */
    public xyLines: number[][];

    public xLabelTranslation: number;

    /**
     *
     */
    constructor ()
    {
        this.xyLines = [[0, 0], [0, 0],[0, 0]];
        this.vpos = new VerticalPosition();
    }

}
export class DataPiePoint
{
    public placement?: Placement;
    public labelBoundingBox?: BoundingBox;

    constructor (public label: string, public value: number, public color: string, public colorHover: string, public dataKey?: string | number)
    {
        this.placement = new Placement();
        this.labelBoundingBox = new BoundingBox();
    }
}
